/* globals Blob, console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const fileSaver = require('file-saver'),
    Marionette = require('backbone.marionette'),
    // jQuery = require('jquery'),
    _ = require('lodash'),
    //
    Filters = require('../collections/filters'),
    Organizations = require('../collections/organizations'),
    Programs = require('../collections/programs'),
    FiltersList = require('./filtersList'),
    templates = require('../utilities/handlebars').templates,
    helpers = require('../utilities/handlebars').helpers,
    configuration = require('../utilities/configuration'),
    enumerations = require('../utilities/enumerations').enumerations,
    codeValues = require('../utilities/enumerations').codeValues,
    EOL = null;
    // organizationStatusTypes = (function () {
    //     const o = {};
    //     _.each
    // })();

module.exports = Marionette.View.extend({
    attributes: {
        class: 'reports card card-body hidden'
    },
    events: {
        'change select':  'onChangeSelect',
        'change input':   'onChangeInput',
        'click button':   'onClickButton',
        'click th':       'onClickHeader',
        'click tbody tr': 'onClickRow'
    },
    regions: {
        filtersList: {el: 'div[name=filtersList]', replaceElement: true}
    },
    sortColumnIndex: null,
    sortColumnDirection: 'ascending',
    tagName: 'div',
    template: templates.reports,
    //
    initialize: function () {
        this.filteredPrograms = this.options.filteredPrograms;
        this.filters = new Filters();
        this.organizations = new Organizations([], {skipReload: true});
        this.programs = new Programs([], {via: 'reports'});
        this.organizations.reload();
        this.programs.applyProcessedFilters({invalidateCache: new Date().getTime()});
        this.listenTo(this.organizations, 'sync', _.bind(function () {
            if (this.reportType && this.reportType.indexOf('organizations') !== -1) {
                this.renderTable();
            }
        }, this));
        this.listenTo(this.programs, 'sync', _.bind(function () {
            if (this.reportType && this.reportType.indexOf('programs') !== -1) {
                this.renderTable();
            }
        }, this));
        this.listenTo(this.filteredPrograms, 'sync', _.bind(function () {
            if (this.reportType === 'programsFiltered') {
                this.renderTable();
            }
        }, this));
    },
    onChangeInput: function (event) {
        if (event.currentTarget.dataset.filter) {
            this.$el.find('form[name=programs] div[data-columns=true] input').attr('disabled', event.currentTarget.checked ? true : false);
        }
    },
    onChangeSelect: function (event) {
        this.reportType = event.currentTarget.value;
        this.$el.find('[data-name=table]').html('');
        this.$el.find('button[data-action=saveCsv]').attr('disabled', false);
        this.renderTable();
        // this.$el.find('div[data-type=all], div[data-type=' + this.reportType + ']').removeClass('d-none');
        // this.$el.find('div[data-type=' + (this.reportType === 'organizations' ? 'programs' : 'organizations') + ']').addClass('d-none');
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        let blob;
        switch (action) {
            // case 'checkAll':
            // case 'checkNone':
            //     this.$el.find('form[name=' + this.reportType + '] input[type=checkbox]').attr('checked', action === 'checkAll');
            //     break;
            case 'saveCsv':
                blob = new Blob([this.$el.find('[data-name=csv] pre').text()], {type: 'text/csv;charset=utf-8'});
                fileSaver.saveAs(blob, this.reportType + '.csv');
                break;
            // case 'fetch':
            //     this.renderTable();
            //     this.$el.find('button[data-action=saveCsv]').attr('disabled', false);
            //     break;
            default:
                break;
        }
    },
    onClickHeader: function (event) {
        this.renderTable(event.currentTarget.dataset.column);
    },
    onClickRow: function (event) {
        const o = this.ids[event.currentTarget.rowIndex - 1];
        if (o) {
            if (o.programId) {
                this.trigger('select:program', o);
            } else {
                this.trigger('select:organization', o);
            }
        }
    },
    onRender: function () {
        this.filtersList = this.showChildView('filtersList', new FiltersList({collection: this.filters, popout: true, report: true}));
        this.filtersList.$el.addClass('d-none');
    },
    reload: function () {
        this.organizations.reload();
        this.programs.reload();
    },
    renderTable: function (sortColumn) {
        const o = {
                columnCount: 0,
                columns: [],
                rows: [],
                csv: [],
                reportType: this.reportType,
                hot: true
            },
            reportColumns = {
                organizationsList: [
                    {name: 'id', value: 'idColumnTitle'},
                    {name: 'name', value: 'organizationNameColumnTitle'},
                    {name: 'address_derived', value: 'addressColumnTitle'},
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'phone', value: 'phoneColumnTitle'},
                    {name: 'primaryName_derived', value: 'primaryContactNameColumnTitle'},
                    {name: 'primaryPhone', value: 'primaryContactPhoneColumnTitle'},
                    {name: 'primaryEmail', value: 'primaryContactEmailColumnTitle'},
                    {name: 'programs', value: 'programCountColumnTitle', icon: {src: configuration.assetBase + 'images/programs.svg', alt: 'Programs'}},
                    {name: 'beds', value: 'bedCountColumnTitle', icon: {src: configuration.assetBase + 'images/units.svg', alt: 'Beds'}},
                    {name: 'vacancies', value: 'vacancyCountColumnTitle', icon: {src: configuration.assetBase + 'images/vacancies.svg', alt: 'Vacancies'}},
                    {name: 'createdTime', value: 'createdTimeColumnTitle'},
                    {name: 'modifiedTime', value: 'modifiedTimeColumnTitle'},
                    {name: 'daysSinceModified_derived', value: 'daysSinceModifiedColumnTitle'}
                ],
                organizationsToVerify: [
                    {name: 'id', value: 'idColumnTitle'},
                    {name: 'organizationStatusTypeId', value: 'organizationStatusColumnTitle'},
                    {name: 'name', value: 'organizationNameColumnTitle'},
                    {name: 'address_derived', value: 'addressColumnTitle'},
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'phone', value: 'phoneColumnTitle'},
                    {name: 'programs', value: 'programCountColumnTitle', icon: {src: configuration.assetBase + 'images/programs.svg', alt: 'Programs'}},
                    {name: 'beds', value: 'bedCountColumnTitle', icon: {src: configuration.assetBase + 'images/units.svg', alt: 'Beds'}},
                    {name: 'primaryName_derived', value: 'primaryContactNameColumnTitle'},
                    {name: 'primaryPhone', value: 'primaryContactPhoneColumnTitle'},
                    {name: 'primaryEmail', value: 'primaryContactEmailColumnTitle'}
                ],
                organizationsEngagement: [
                    {name: 'name', value: 'organizationNameColumnTitle'},
                    {name: 'modifiedTime', value: 'modifiedTimeColumnTitle'},
                    {name: 'daysSinceModified_derived', value: 'daysSinceModifiedColumnTitle'}
                ],
                programsList: [
                    {name: 'id', value: 'idColumnTitle'},
                    {name: 'name', value: 'programNameColumnTitle'},
                    {name: 'organizationId', value: 'organizationNameColumnTitle'},
                    {name: 'programTypeId', value: 'programTypeColumnTitle'},
                    {name: 'address_derived', value: 'addressColumnTitle'},
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'primaryName_derived', value: 'primaryContactNameColumnTitle'},
                    {name: 'primaryPhone', value: 'primaryContactPhoneColumnTitle'},
                    {name: 'primaryEmail', value: 'primaryContactEmailColumnTitle'},
                    {name: 'units', value: 'unitCountColumnTitle', icon: {src: configuration.assetBase + 'images/units.svg', alt: 'Beds'}},
                    {name: 'vacancies', value: 'vacancyCountColumnTitle', icon: {src: configuration.assetBase + 'images/vacancies.svg', alt: 'Vacancies'}},
                    {name: 'createdTime', value: 'createdTimeColumnTitle'},
                    {name: 'modifiedTime', value: 'modifiedTimeColumnTitle'},
                    {name: 'daysSinceModified_derived', value: 'daysSinceModifiedColumnTitle'}
                ],
                programsToVerify: [
                    {name: 'id', value: 'idColumnTitle'},
                    {name: 'programStatusTypeId', value: 'programStatusColumnTitle'},
                    {name: 'name', value: 'programNameColumnTitle'},
                    {name: 'organizationId', value: 'organizationNameColumnTitle'},
                    {name: 'programTypeId', value: 'programTypeColumnTitle'},
                    {name: 'address_derived', value: 'addressColumnTitle'},
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'primaryName_derived', value: 'primaryContactNameColumnTitle'},
                    {name: 'primaryPhone', value: 'primaryContactPhoneColumnTitle'},
                    {name: 'primaryEmail', value: 'primaryContactEmailColumnTitle'},
                    {name: 'units', value: 'unitCountColumnTitle', icon: {src: configuration.assetBase + 'images/units.svg', alt: 'Beds'}}
                ],
                programsCounty: [
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'totalProgramsPerCounty_derived', value: 'Total Programs'}
                ],
                programsFiltered: [
                    {name: 'id', value: 'idColumnTitle'},
                    {name: 'name', value: 'programNameColumnTitle'},
                    {name: 'organizationId', value: 'organizationNameColumnTitle'},
                    {name: 'programTypeId', value: 'programTypeColumnTitle'},
                    {name: 'address_derived', value: 'addressColumnTitle'},
                    {name: 'countyId', value: 'countyColumnTitle'},
                    {name: 'primaryName_derived', value: 'primaryContactNameColumnTitle'},
                    {name: 'primaryPhone', value: 'primaryContactPhoneColumnTitle'},
                    {name: 'primaryEmail', value: 'primaryContactEmailColumnTitle'},
                    {name: 'units', value: 'unitCountColumnTitle', icon: {src: configuration.assetBase + 'images/units.svg', alt: 'Beds'}},
                    {name: 'vacancies', value: 'vacancyCountColumnTitle', icon: {src: configuration.assetBase + 'images/vacancies.svg', alt: 'Vacancies'}},
                    {name: 'modifiedTime', value: 'modifiedTimeColumnTitle'},
                    {name: 'daysSinceModified_derived', value: 'daysSinceModifiedColumnTitle'}
                ]
            },
            formatValue = _.bind(function (column, value) {
                if (column === 'organizationId') {
                    return this.organizations.get(value) ? this.organizations.get(value).get('name') : 'Other';
                }
                if (column.substr(-2) === 'Id') {
                    return helpers.enumL10n({property: column, id: value});
                }
                if (column.substr(-4) === 'Time') {
                    return new Date(value).toISOString().substr(0, 10);
                }
                if (column.toLowerCase().indexOf('phone') !== -1) {
                    return helpers.telephone(value);
                }
                return value;
            }, this),
            numerics = {
                beds: true,
                daysSinceModified: true,
                id: true,
                programs: true,
                vacancies: true
            },
            columnNamesDisplayOrder = [],
            derivedColumns = {},
            filters = {},
            // form = {},
            commas = function (count) {
                let s = '';
                for (let i = 0; i < count; i++) {
                    s += ',';
                }
                return s;
            },
            columnIcons = {};
        let columnNames = {},
            columnCount = 0,
            currentFilters,
            isAscending,
            newSortColumnIndex,
            sortWeight,
            models;
        this.ids = [];
        if (!sortColumn) {
            this.sortColumnIndex = null;
            this.sortColumnDirection = 'ascending';
        }
        _.each(reportColumns[this.reportType], _.bind(function (nameValue) {
            const a = nameValue.name.split('_');
            let isColumn = true;
            if (a.length > 1) {
                switch (a[1]) {
                    case 'derived':
                        derivedColumns[a[0]] = true;
                        break;
                    case 'filter':
                        isColumn = false;
                        filters[a[0]] = true;
                        break;
                    default:
                        break;
                }
            }
            if (isColumn) {
                columnNames[a[0]] = nameValue.value;
                columnNamesDisplayOrder.push(a[0]);
                if (nameValue.icon) {
                    columnIcons[a[0]] = {src: nameValue.icon.src, alt: nameValue.icon.alt};
                }
            }
        }, this));
        this.filtersList.$el.toggleClass('d-none', this.reportType !== 'programsFiltered');
        if (this.reportType === 'programsFiltered') {
            currentFilters = _.clone(this.filteredPrograms.currentFilters());
            delete currentFilters.sortby;
            this.filtersList.updateProcessedFilters(currentFilters);
        }
        if (this.reportType === 'programsCounty') {
            // @acavan! user reportColumns.programsCounty here...
            o.hot = false;
            columnNames = {
                countyId: 'County',
                totalProgramsPerCounty: 'Total Programs'
            };
            o.columns = [
                {column: 'countyId', title: 'countyColumnTitle'},
                {column: 'totalProgramsPerCounty', title: 'totalProgramsPerCountyColumnTitle'}
            ];
            o.countyIds = {};
            _.each(this.programs.models, function (model) {
                if (!o.countyIds[model.get('countyId')]) {
                    o.countyIds[model.get('countyId')] = 0;
                }
                o.countyIds[model.get('countyId')]++;
            });
            _.each(o.countyIds, function (count, countyId) {
                const county = enumerations.countyId[countyId];
                o.rows.push([county ? helpers.l10n(county.code) : countyId, count]);
            });
        } else {
            o[this.reportType] = true;
            _.each(columnNamesDisplayOrder, function (column) {
                if (column === 'id') {
                    o.suppressId = true;
                }
                o.columns.push({column: column, title: columnNames[column], src: columnIcons[column] ? columnIcons[column].src : null, alt: columnIcons[column] ? columnIcons[column].alt : null});
            });
            o.columnCount = o.columns.length;
            if (this.reportType === 'programsFiltered') {
                models = this.filteredPrograms.models;
            } else {
                models = this[this.reportType.substr(0, 13) === 'organizations' ? 'organizations' : 'programs'].models;
            }
            _.each(models, _.bind(function (model) {
                const a = [];
                // let columnName,
                let attributes = model.toJSON();
                if (this.reportType === 'organizationsToVerify' && model.attributes.organizationStatusTypeId !== codeValues.organizationStatusTypeVerify) {
                    return;
                }
                if (this.reportType === 'programsToVerify' && model.attributes.programStatusTypeId !== codeValues.programStatusTypeVerify) {
                    return;
                }
                if (this.reportType === 'programsFiltered') {
                    if (model.hidden) {
                        return;
                    }
                    if (this.programs.get(model.id)) {
                        attributes = this.programs.get(model.id).toJSON();
                    }
                }
                // this.ids.push(model.get('organizationId') ? model.get('organizationId') + ':' + model.get('id') : model.get('id') + '');
                _.each(columnNamesDisplayOrder, function (column) {
                    if (!derivedColumns[column]) {
                        a.push(formatValue(column, attributes[column]));
                    } else {
                        switch (column) {
                            case 'address':
                                a.push(_.filter(_.map(['address1', 'address2', 'city', 'state', 'zip'], function (attribute) {
                                    return attributes[attribute];
                                })).join(', '));
                                break;
                            case 'daysSinceModified':
                                try {
                                    a.push(Math.floor((new Date().getTime() - new Date(attributes.modifiedTime).getTime()) / (1000 * 60 * 60 * 24)));
                                } catch (error) {
                                    a.push('❦' + column);
                                }
                                break;
                            case 'primaryName':
                                a.push(_.filter(_.map(['primaryFirst', 'primaryLast'], function (attribute) {
                                    return attributes[attribute];
                                })).join(' '));
                                break;
                            default:
                                a.push('❦' + column);
                                break;
                        }
                    }
                });
                // stash the organization or organization:program at the end of the row data
                // a.push(model.get('organizationId') ? model.get('organizationId') + ':' + model.get('id') : model.get('id') + '');
                a.push(model.get('organizationId') ? {organizationId: model.get('organizationId'), programId: model.get('id')} : {organizationId: model.get('id')});
                o.rows.push(a);
            }, this));
        }
        if (sortColumn) {
            newSortColumnIndex = _.keys(columnNames).indexOf(sortColumn);
            if (this.sortColumnIndex === newSortColumnIndex) {
                this.sortColumnDirection = this.sortColumnDirection === 'ascending' ? 'descending' : 'ascending';
            } else {
                this.sortColumnDirection = 'ascending';
            }
            this.sortColumnIndex = newSortColumnIndex;
        }
        if (this.sortColumnIndex !== null) {
            isAscending = this.sortColumnDirection === 'ascending';
            o.columns[this.sortColumnIndex].sorted = this.sortColumnDirection;
            if (numerics[sortColumn]) {
                sortWeight = isAscending ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
            } else {
                sortWeight = isAscending ? '_' : ' ';
            }
            o.rows = _.orderBy(
                o.rows,
                _.bind(function (row) {
                    let value = row[this.sortColumnIndex];
                    if (_.isString(value)) {
                        value = value.toLowerCase();
                    }
                    return (value === 0 ? 0 : (value || sortWeight));
                }, this),
                isAscending ? 'asc' : 'desc'
            );
        }
        if (this.reportType !== 'programsCounty') {
            _.each(o.rows, _.bind(function (row) {
                // remove the organization or organization:program from the row data and store in the ids table (in post sort row order for retrieval by row number on click)
                this.ids.push(row.pop()); //
            }, this));
        }
        columnCount = _.values(columnNames).length;
        o.csv.push('HB101 Places: ' + _.startCase(this.reportType) + commas(columnCount - 1));
        o.csv.push('"' + (new Date().toLocaleString()) + '"' + commas(columnCount - 1));
        if (this.reportType === 'programsFiltered') {
            o.csv.push('"Filters:","' + _.map(_.remove(this.filtersList.$el.text().split('\n'), function (s) {return s.length;}), function (v) {
                // in csvlandia, if values are double quote delimited, double quotes in a string are escaped with another double quote...
                // e.g., 'qwe "asd" zxc' -> '"qwe ""asd"" zxc"'
                return _.isString(v) ? v.replace(/"/g, '""') : v;
            }).join('","') + '"');
        }
        o.csv.push(commas(columnCount));
        o.csv.push('"' + _.values(columnNames).join('","') + '"');
        _.each(o.rows, function (row) {
            o.csv.push('"' + _.map(row, function (v) {
                // in csvlandia, if values are double quote delimited, double quotes in a string are escaped with another double quote...
                // e.g., 'qwe "asd" zxc' -> '"qwe ""asd"" zxc"'
                return _.isString(v) ? v.replace(/"/g, '""') : v;
            }).join('","') + '"');
        });
        // console.log(this.ids);
        // console.log(o);
        this.$el.find('div[data-name=table]').html(templates.reportsTable(o));
        this.$el.find('div[data-name=csv] pre').text(o.csv.join('\n'));
    }
});
